import React from 'react';
import { convertToLocalDate } from 'smart-react';

/**
 * Returns a grid date.
 * @param {*} props
 * @returns {JSX.Element} returns row cell
 */
export const GridDateCell = (props) => {
  let value = '';
  const { dataItem, field } = props;

  if (field?.includes('.')) {
    const fields = field?.split('.');
    value = dataItem[fields[0]][fields[1]];
  } else {
    value = dataItem[field];
  }
  return <td>{convertToLocalDate(value)}</td>;
};
